import './styles/globalstyles.css';
// routes
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ThemeSettings from './components/settings';
import { ChartStyle } from './components/chart';
import ScrollToTop from './components/ScrollToTop';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
// import GlobalSpinner from './components/GlobalSpinner'

// ----------------------------------------------------------------------

const queryClient = new QueryClient();

export default function App() {
  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          {/* <GlobalSpinner /> */}
          <QueryClientProvider client={queryClient}>
            <ChartStyle />
            <ScrollToTop />
            <Router />
          </QueryClientProvider>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
